<!-- 
    描述：外部对接字典 --- 右侧关联字典表table
    时间：2021/03/02
    Created by zl 
-->
<template>
	<div class="h100 right-dict-table">
		<div class="w-table-layout w-table-page">
			<div class="w-table-content"
				 ref="dictTable">
				<vxe-table :data="dictData"
						   :loading="loading"
						   highlight-current-row
						   highlight-hover-row
						   height="100%"
						   border
						   ref="dictData"
						   size="small"
						   :tree-config="{ children: 'children' }"
						   show-overflow="tooltip"
						   show-header-overflow="tooltip"
						   @current-change="rowClick">
					<vxe-table-column field="value"
									  title="字典编号"
									  width="190px"
									  tree-node
									  header-align="center"></vxe-table-column>
					<vxe-table-column field="sname"
									  title="字典名称"
									  width="120px"
									  header-align="center"></vxe-table-column>
					<vxe-table-column field="alias"
									  title="英文名称"
									  width="120px"
									  align="center"></vxe-table-column>
					<vxe-table-column field="sort"
									  title="排序"
									  width="100px"
									  align="center"></vxe-table-column>
					<vxe-table-column field=""
									  title="父级字典"
									  width="120px"
									  align="center"></vxe-table-column>
					<vxe-table-column field="remarks"
									  title="备注"
									  min-width="200px"
									  header-align="center"></vxe-table-column>
					<vxe-table-column field="isFlag"
									  title="是否生效"
									  width="100px"
									  align="center">
						<template v-slot="{ row }">
							<el-switch v-model="row.isFlag"
									   class="switch"
									   active-color="#2671cc"
									   inactive-color="#cccccc"
									   :active-value="1"
									   :inactive-value="0"
									   active-text="生效"
									   inactive-text="禁用"
									   disabled
									   :class="{ opacityHide: !roleBtns.includes('enable_dict') }"
									   @click.native.prevent="statusChange(row)">
							</el-switch>
						</template>
					</vxe-table-column>
					<vxe-table-column title="操作"
									  min-width="230px"
									  align="center">
						<template v-slot="{ row }">
							<el-button type="success"
									   round
									   plain
									   class="table-btn"
									   v-if="roleBtns.includes('add_dict_child')"
									   @click="doClick('add', row)">
								<svg-icon icon-class="form-add"></svg-icon> 新增
							</el-button>
							<el-button type="success"
									   round
									   plain
									   class="table-btn"
									   @click="doClick('edit', row)"
									   v-if="roleBtns.includes('edit_dict_child')"
									   :disabled="row.isFlag == null">
								<svg-icon icon-class="form-edit"></svg-icon> 编辑
							</el-button>
							<el-button type="danger"
									   round
									   plain
									   class="table-btn hidden"
									   icon="el-icon-delete"
									   @click="doDelete(row)">删除
							</el-button>
						</template>
					</vxe-table-column>
				</vxe-table>
			</div>
			<div class="w-table-footer">
				<el-pagination @size-change="handleSizeChange"
							   @current-change="handleCurrentChange"
							   :current-page="pageObj.currentPage"
							   :page-sizes="pageObj.pageList"
							   :page-size="pageObj.pageSize"
							   class="mt5"
							   layout="total, sizes, prev, pager, next, jumper"
							   :total="pageObj.total"></el-pagination>
			</div>
		</div>

		<!-- 添加关联弹窗 -->
		<el-dialog v-if="dialogObj.show"
				   :title="dialogObj.title"
				   :visible.sync="dialogObj.show"
				   :width="dialogObj.width"
				   center
				   :close-on-click-modal="false"
				   @closed="doCancel">
			<el-form :model="associatedForm"
					 label-width="120px"
					 :rules="associatedRule"
					 ref="associatedRef">
				<el-form-item label="外部对接平台">
					<el-input v-model="leftObj.sname"
							  disabled></el-input>
				</el-form-item>
				<el-form-item label="关联字典"
							  prop="dict">
					<el-select v-model="associatedForm.dict"
							   placeholder="请选择">
						<el-option v-for="item in associatedDictList"
								   :key="'dict' + item.value"
								   :label="item.value + '：' +item.sname"
								   :value="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button class="btn"
						   @click="doCancel('associated')">取 消</el-button>
				<el-button class="btn btn-blue"
						   type="primary"
						   @click="doSubmit">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 新增、编辑字典 -->
		<el-dialog :title="dictObj.title"
				   :visible.sync="dictObj.show"
				   :width="dictObj.width"
				   center
				   :close-on-click-modal="false"
				   @closed="doCancelDict">
			<el-form :model="dictForm"
					 label-width="120px"
					 :rules="dictRule"
					 ref="dictRef">
				<el-form-item label="所属字典"
							  required>
					<el-input v-model="belongToDictName"
							  placeholder="请输入"
							  disabled></el-input>
				</el-form-item>
				<el-form-item label="字典名称"
							  prop="sname">
					<el-input v-model="dictForm.sname"
							  placeholder="请输入字典名称"></el-input>
				</el-form-item>
				<el-form-item label="英文别名"
							  prop="alias">
					<el-input v-model="dictForm.alias"
							  placeholder="请输入英文别名"></el-input>
				</el-form-item>
				<el-form-item label="外部平台字典值"
							  prop="outValue">
					<el-input v-model="dictForm.outValue"
							  placeholder="请输入外部平台字典值"></el-input>
				</el-form-item>
				<el-form-item label="排序"
							  prop="sort">
					<el-input v-model="dictForm.sort"
							  placeholder="请输入排序"
							  v-input-filter:int></el-input>
				</el-form-item>
				<el-form-item label="备注"
							  prop="remarks">
					<el-input v-model="dictForm.remarks"
							  placeholder="请输入备注"
							  type="textarea"
							  :rows="3"
							  maxlength="50"
							  show-word-limit></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button class="btn"
						   @click="doCancelDict">取 消</el-button>
				<el-button class="btn btn-blue"
						   type="primary"
						   @click="doSubmitDict">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import {
	getDictRootNods,
	saveOrUpdateDictOut,
	getDictOutTreeList,
	sumitRelatDict,
	updateDictOutFlag,
} from 'api/modules/dict'
import { mapState } from 'vuex'
export default {
	name: 'RightDictionaryTable',
	props: {},
	data() {
		return {
			dictData: [], //关联字典表
			loading: false,

			pageObj: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50],
			}, //分页

			// 添加关联弹窗对象
			dialogObj: {
				title: '添加关联',
				width: '700px',
				show: false,
			},

			// 新增、编辑字典弹窗对象
			dictObj: {
				title: '新增字典',
				width: '700px',
				show: false,
			},

			// 添加关联表单对象
			associatedForm: {
				dict: '', // 关联字典
			},

			associatedDictList: [], //关联字典列表

			// 新增、编辑字典表单对象
			dictForm: {
				sname: '', //字典名称
				alias: '', //英文别名
				sort: '', //排序
				value: '', //字典值
				outValue: '', //码表值
				remarks: '', //备注
			},

			// 添加关联表格规则
			associatedRule: {
				dict: [
					{
						required: true,
						message: '关联字典不能为空',
						trigger: 'change',
					},
				],
			},

			// 添加、编辑字典表格规则
			dictRule: {
				sname: [
					{
						required: true,
						message: '字典名称不能为空',
						trigger: 'blur',
					},
				],
				alias: [
					{
						required: true,
						message: '英文别名不能为空',
						trigger: 'blur',
					},
				],
				sort: [
					{
						required: true,
						message: '排序不能为空',
						trigger: 'blur',
					},
				],
				outValue: [
					{
						required: true,
						message: '外部平台字典值不能为空',
						trigger: 'blur',
					},
				],
			},

			// 左侧选择的平台
			leftObj: {},

			parentId: '',

			belongToDictName: '', //所属字典

			searchObj: {
				sname: '',
			},
		}
	},
	created() {
		this.getDictList()
		this.getAssociatedList()
	},
	methods: {
		// 获取关联的字典表
		getDictList() {
			this.loading = true
			this.$nextTick(() => {
				getDictOutTreeList({
					platformId: this.leftObj.id,
				})
					.then((res) => {
						this.dictData = res.data.records
						this.pageObj.total = parseInt(res.data.total)
						this.loading = false
					})
					.catch(() => {
						this.loading = false
					})
			})
		},

		// 获取添加关联的关联字典列表
		getAssociatedList() {
			getDictRootNods().then((res) => {
				if (res.operationCode == 1) {
					this.associatedDictList = res.data
				}
			})
		},

		// 添加关联弹窗取消按钮
		doCancel() {
			this.dialogObj.show = false
			this.associatedForm.dict = ''
		},

		// 新增、修改字典取消按钮
		doCancelDict() {
			this.dictForm.sname = ''
			this.dictForm.alias = ''
			this.dictForm.outValue = ''
			this.dictForm.sort = ''
			this.dictForm.remarks = ''
			this.dictObj.show = false
		},

		// 弹窗确认按钮
		doSubmit() {
			this.$refs.associatedRef.validate((valid) => {
				if (valid) {
					sumitRelatDict({
						platformId: this.leftObj.id,
						value: this.associatedForm.dict,
					}).then((res) => {
						if (res.operationCode == 1) {
							this.getDictList()
							this.doCancel()
							this.$message.success('添加关联完成！')
						} else {
							this.$message.error(res.msg)
						}
					})
				}
			})
		},

		//	新增、修改字典
		doSubmitDict() {
			this.$refs.dictRef.validate((valid) => {
				if (valid) {
					let params = Object.assign({}, this.dictForm)
					params.platformId = this.leftObj.id
					params.parentId ? '' : (params.parentId = this.parentId)
					saveOrUpdateDictOut(params).then(() => {
						this.$message.success('操作完成！')
						this.dictForm.id = ''
						this.dictForm.value = ''
						this.dictForm.parentId = ''
						this.doCancelDict()
						this.getDictList()
					})
				}
			})
		},

		// 添加关联/新增、编辑字典 点击事件
		doClick(type, data) {
			if (type == 'add') {
				this.dictObj.show = true
				this.dictObj.title = '新增字典'
			} else if (type == 'edit') {
				this.dictObj.show = true
				this.dictObj.title = '编辑字典'

				let params = Object.assign({}, data)
				this.dictForm.sname = params.sname
				this.dictForm.alias = params.alias
				this.dictForm.outValue = params.outValue
				this.dictForm.sort = params.sort + ''
				this.dictForm.remarks = params.remarks
				this.dictForm.id = params.id
				this.dictForm.parentId = params.parentId
				this.dictForm.value = params.value
			} else {
				if (this.leftObj.id) {
					this.dialogObj.show = true
				} else {
					this.$message.warning(
						'请先选择平台，再添加关联，如果没有平台请先添加平台！'
					)
				}
			}
		},

		// 删除
		doDelete(row) {
			this.$confirm('此操作将删除该字典', '提示', {
				confirmButtonText: '确 认',
				cancelButtonText: '取 消',
				type: 'warning',
			})
				.then(() => {
					this.$message.success('删除成功！')
				})
				.catch(() => {
					this.$message.info('操作取消！')
				})
		},

		// 状态改变
		statusChange(row) {
			if (this.roleBtns.includes('enable_dict')) {
				let _flag = row.isFlag == 0 ? 1 : 0
				this.$confirm('是否确认改变该码表的状态', '提示', {
					confirmButtonText: '确 认',
					cancelButtonText: '取 消',
					type: 'warning',
				})
					.then(() => {
						updateDictOutFlag({
							id: row.id,
							platformId: this.leftObj.id,
							isFlag: _flag,
						}).then((res) => {
							if (res.operationCode == 1) {
								this.$message.success('修改成功！')
								this.getDictList()
							} else {
								this.$message.error(res.msg)
							}
						})
					})
					.catch(() => {
						this.$message.info('操作取消！')
					})
			} else {
				this.$message.warning('当前账号没权限进行此操作！')
			}
		},

		// row点击
		rowClick(data) {
			this.parentId = data.row.id
			if (data.row.parentId != '0') {
				this.dictData.find((x) => {
					if (data.row.value.indexOf(x.value) != -1) {
						this.belongToDictName = x.sname
					}
				})
			} else {
				this.belongToDictName = data.row.sname
			}
		},

		// 切换显示条数
		handleSizeChange(size) {
			this.pageObj.pageSize = size
			this.getDictList()
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.pageObj.currentPage = cur
			this.getDictList()
		},

		//前台查询列表信息，不走后台接口
		queryTableList(sname) {
			let that = this
			const XEUtils = require('xe-utils')
			let options = { children: 'children' }
			let searchProps = ['sname']
			this.dictData = XEUtils.searchTree(
				that.dictData,
				(item) =>
					searchProps.some(
						(key) => XEUtils.toString(item[key]).indexOf(sname) > -1
					),
				options
			)

			// 搜索之后默认展开所有子节点
			this.$nextTick(() => {
				this.$refs.dictData.setAllTreeExpand(true)
			})
		},

		searchTablePageList(searchObj) {
			let that = this
			this.searchObj = searchObj
			let sname = this.searchObj.sname
			if (sname != '') {
				//前台查询列表信息（不分页），不走后台接口
				that.queryTableList(sname)
			} else {
				//条件为空，查询后台列表接口（分页），获取字典列表信息
				this.pageObj.currentPage = 1
				this.pageObj.pageSize = 10
				this.getDictList()
			}
		},
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns, //按钮权限
		}),
	},
}
</script>
<style lang='less' scoped>
.right-dict-table {
	.switch {
		/deep/ .el-switch__label--right span {
			margin-left: -15px;
		}
		/deep/ .el-switch__label {
			cursor: pointer !important;
		}
	}

	.el-switch.is-disabled {
		opacity: 1;
	}
}
</style>
